import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from 'moment';
import {InfoRounded} from "@mui/icons-material";

export const DateCell = ({
                           props,
                           schema,
                         }: {
  props: any;
  schema: any;
}): ReactElement => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current as HTMLDivElement;
      const parentElement = divElement.parentNode as HTMLElement;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return { element: 0, cell: 0 };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth = getDivWidth(divRef);
    if (divWidth.element > divWidth.cell) setTooltip(true);
  }, [props?.value]);

  if (!props?.value) return <></>;

  const momentDate = props?.value ? moment(props.value) : null;

  const formattedDate =
    schema?.viewTable === 'activity_reservations' ||
    schema?.viewTable === 'accommodation_reservations' ||
    schema?.viewTable === 'groups'
      ? momentDate
        ? momentDate.format('YYYY-MM-DD ddd')
        : null
      : momentDate
        ? momentDate.format('YYYY-MM-DD')
        : null;

  const isAfterMidnight = Boolean(props?.row?.is_after_midnight);

  return (
    <Box
      ref={divRef}
      className={`${tooltip ? 'has-tooltip' : 'doesnthave-tooltip'}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 0,
        position: 'relative'
    }}
    >
      {tooltip ? (
        <Tooltip
          disableInteractive
          title={formattedDate ?? ''}
          slotProps={{
            tooltip: { sx: { fontSize: '13px' } },
            popper: {
              modifiers: [{ name: 'offset', options: { offset: [0, -14] } }],
            },
          }}
        >
          <span style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isAfterMidnight ? '#d32f2f' : ''
          }}>
            {formattedDate ?? ''}
          </span>
        </Tooltip>
      ) : (
        <span style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: isAfterMidnight ? '#d32f2f' : '',
        }}>
          {formattedDate ?? ''}
        </span>
      )}

      {isAfterMidnight && (
        <Tooltip
          title={`Technically it still belongs to the previous day (${props?.row?.date_minus_day})`}
          slotProps={{ tooltip: { sx: { fontSize: '13px' } } }}
        >
          <InfoRounded
            fontSize="small"
            sx={{
              color: 'error.main',
              flex: '0 0 auto',
              cursor: 'default',
              position: 'absolute',
              top: '-4px',
              right: '-12px',
              fontSize: '12px',
          }}
          />
        </Tooltip>
      )}
    </Box>
  );
};
